"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoComplete = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactScroll = require("react-scroll");

var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));

var _components = require("../../components");

var _DocumentProvider = require("../../context/DocumentProvider");

var _useOnClickOutside = _interopRequireDefault(require("../../lib/utils/hooks/useOnClickOutside"));

var _AutoComplete = require("./AutoComplete.style");

var _helper = require("../../lib/utils/helper");

var SuggestionList = function SuggestionList(_ref) {
  var renderSuggestions = _ref.renderSuggestions,
      setShowSuggestions = _ref.setShowSuggestions,
      setNavbarSearch = _ref.setNavbarSearch;
  var searchContainer = (0, _react.useRef)(null);
  (0, _useOnClickOutside.default)(searchContainer, function () {
    setShowSuggestions(false);
    setNavbarSearch(false);
  });
  return /*#__PURE__*/_react.default.createElement(_AutoComplete.ListWrapper, {
    ref: searchContainer
  }, renderSuggestions());
};

var AutoComplete = function AutoComplete(_ref2) {
  var setNavbarSearch = _ref2.setNavbarSearch,
      searchData = _ref2.searchData;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      userInput = _useState2[0],
      setUserInput = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showSuggestions = _useState4[0],
      setShowSuggestions = _useState4[1];

  var inputRef = (0, _react.useRef)(null);
  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var _useContext = (0, _react.useContext)(_DocumentProvider.DocumentContext),
      currentDocument = _useContext.currentDocument;

  (0, _useOnClickOutside.default)(inputRef, function () {
    if (!showSuggestions) {
      setNavbarSearch(false);
    }
  });

  var openAttachment = function openAttachment(fileName) {
    console.log('[openAttachment] fileName: ', fileName);
    var attachmentFile = currentDocument.attachments.find(function (att) {
      return att.title === fileName;
    });
    var id = attachmentFile.id;
    var type = attachmentFile.mediaType === 'text/xml' ? 'xml' : 'pdf';
    var title = attachmentFile.title;
    navigate({
      search: "?attachment=".concat(id, "&type=").concat(type, "&title=").concat(title)
    }, {
      replace: true
    });
  };

  var renderSuggestions = function renderSuggestions() {
    var searchLimit = 20;
    var filteredData = {};
    if (!searchData) return;
    searchData.forEach(function (suggestion) {
      var _filteredData$suggest;

      filteredData[suggestion.groupTitle] = [];
      var sortData = suggestion.data.filter(function (i) {
        if (i && i.text) {
          var normalizedData = (0, _helper.normalizeString)(i.text);
          var normalizedInput = (0, _helper.normalizeString)(userInput);
          var startCondition = normalizedData.startsWith(normalizedInput);
          var includeCondition = normalizedData.includes(normalizedInput);

          if (startCondition) {
            return startCondition;
          } else if (!startCondition && includeCondition) {
            return includeCondition;
          } else {
            return null;
          }
        }

        return null;
      }).slice(0, searchLimit);

      (_filteredData$suggest = filteredData[suggestion.groupTitle]).push.apply(_filteredData$suggest, (0, _toConsumableArray2.default)(sortData));
    });
    return Object.keys(filteredData).map(function (category, i) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, filteredData[category].length ? /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: i
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "suggestion-item suggestion-category"
      }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
        title: category
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "suggestion-header-category"
      }, category)), /*#__PURE__*/_react.default.createElement("div", {
        className: "suggestion-list"
      }, filteredData[category].map(function (suggestion, i) {
        return /*#__PURE__*/_react.default.createElement(_reactScroll.Link, {
          key: i,
          to: category === 'Sections' ? suggestion : category === 'Attachments' ? '' : category,
          offset: -250,
          smooth: true,
          spy: true,
          onClick: function onClick() {
            if (category === 'Attachments') {
              openAttachment(suggestion.text);
            } else {
              setSearchParams(function (prev) {
                prev.set('rowId', suggestion.rowId);

                if (suggestion.type === 'text') {
                  prev.set('search', suggestion.text);
                }

                return prev;
              });
            }

            setNavbarSearch(false);
          }
        }, /*#__PURE__*/_react.default.createElement("li", {
          className: "suggestion-item"
        }, /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
          highlightClassName: "highlighted",
          searchWords: [userInput],
          autoEscape: true,
          textToHighlight: suggestion.text
        })));
      }))) : null);
    });
  };

  var _onChange = function onChange(e) {
    setUserInput(e.target.value);
    setShowSuggestions(true);

    if (e.target.value < 1) {
      setShowSuggestions(false);
    }
  };

  (0, _react.useEffect)(function () {
    var textInput = _reactDom.default.findDOMNode(inputRef.current);

    if (textInput !== null) {
      inputRef.current.focus();
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AutoComplete.AutoCompleteWrapper, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    placeholder: "Search...",
    value: userInput,
    onChange: function onChange(e) {
      _onChange(e);
    },
    ref: inputRef
  }), showSuggestions ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SuggestionList, {
    renderSuggestions: renderSuggestions,
    setShowSuggestions: setShowSuggestions,
    setNavbarSearch: setNavbarSearch
  })) : null), /*#__PURE__*/_react.default.createElement(_components.Overlay, {
    show: showSuggestions
  }));
};

exports.AutoComplete = AutoComplete;